export default ".table {\n    width: 100%;\n}";